@if (table) {
  <table htm-table class="studyProgramme">
    <thead>
      <tr>
        <th>{{ table[0].label | translate }}</th>
        <th>{{ table[0].value }}</th>
      </tr>
    </thead>
    <tbody>
      @for (item of table; track item; let i = $index) {
        @if (i > 0) {
          <tr>
            <td>{{ table[i].label | translate }}</td>
            <td><b>{{ table[i].value | capitalize }}</b></td>
          </tr>
        }
      }
    </tbody>
  </table>
}
